import cn from 'classnames';

import styles from './withBackground.module.scss';

interface IProps {
  background: React.ReactNode,
  children: React.ReactNode,
  className?: string,
}

const WithBackground = ({ background, children, className }: IProps) => (
  <div className={ cn(styles.relativeContainer, className) }>
    <div className={ styles.imageAbsolute }>{ background }</div>
    { children }
  </div>
);

export default WithBackground;
